<template>
  <div class="my-1 bg-[#F8F8F8] p-1 rounded text-black">
    <div class="text-xl font-medium mb-1">
      Ringkasan Data Order Dikirim
    </div>
    <BRow class="justify-center gap-5 mx-0">
      <BCol class="bg-[#FFFFFF] p-1 rounded-lg border">
        <div class="mb-1 d-flex gap-2">
          <div class="bg-[#DFF3FF] rounded py-[2px] px-[4px]">
            <span class="k-truck-fast text-[#08A0F7] text-3xl" />
          </div>
          <span class="font-medium align-self-center">Total dalam Perjalanan</span>
        </div>
        <div class="font-semibold text-2xl">
          <b-spinner
            v-if="totalKirim === null"
            small
            variant="primary"
          />
          <span v-else>{{ totalKirim }}</span>
        </div>
      </BCol>
      <BCol class="bg-[#FFFFFF] p-1 rounded-lg border">
        <div class="mb-1 d-flex gap-2">
          <div class="bg-[#FFF2E2] rounded py-[2px] px-[4px]">
            <span class="k-truck-time text-[#FBA63C] text-3xl" />
          </div>
          <span class="font-medium align-self-center">Terkena Kendala</span>
        </div>
        <div class="font-semibold text-2xl">
          <b-spinner
            v-if="totalProblem === null"
            small
            variant="primary"
          />
          <span v-else>{{ totalProblem }}</span>
        </div>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  components: { BRow, BCol },
  props: {
    title: {
      type: String,
      default: '',
    },
    totalKirim: {
      type: Number,
      default: null,
    },
    totalProblem: {
      type: Number,
      default: null,
    },
  },
}
</script>
